module.exports = __webpack_public_path__ + "img/lines-double-end.0129f152.png";